import React from 'react';
import { CloseIcon } from '../svg/CloseIcon';
import { Store } from '../../store';
import { IStore } from '../../store/types';
import StoreAction from '../../store/StoreAction';
// import { IS_SPLAN } from '../../utils/env';
// import { fontSize } from 'html2canvas/dist/types/css/property-descriptors/font-size';

export const HelpModal: React.FC = () => {
  const { dispatch /*store*/ } = React.useContext<IStore>(Store);
  // const { service } = store;
  const Action = new StoreAction(dispatch);

  const closeHandler = () => Action.closeModal();
  const getLink = () => {
    const href = window.location.href;

    if (href.includes('dnz')) {
      return 'https://ezavdnz.expertus.com.ua/872973 ';
    } else if (href.includes('school')) {
      return 'https://edirshkoly.expertus.com.ua/877879';
    }
  };
  return (
    <div className="modal">
      <div className="modal--inner">
        <button className="close-btn" onClick={closeHandler}>
          <CloseIcon />
        </button>
        <h2 className="modal-title">Підказка</h2>
        <p>
          {' '}
          <b>Крок 1. </b>За допомогою умовних позначень Стіни, Вікно, Дверний отвір, Сходи зробіть план приміщення.
        </p>
        <p>
          {' '}
          <b>Крок 2. </b>Розставте на плані умовні позначення Вихід, Запасний вихід, Шляхи евакуації, Напрямок до
          виходу.
        </p>
        <p>
          {' '}
          <b>Крок 3. </b>За допомогою умовних позначень вкажіть, де розташовані вогнегасники, пожежні сповіщувачі,
          пожежний кран-комплект, пожежна драбина, телефон.
        </p>
        <p>
          {' '}
          <b>Крок 4. </b>Щоб працівники могли зорієнтуватися, вкажіть, де вони перебувають, за допомогою знаку «Ви
          перебуваєте тут».
        </p>
        {getLink() && (
          <p>
            На допомогу:&nbsp;
            <a className="link" href={getLink()} target="_blank" style={{ fontSize: '13px' }} rel="noopener noreferrer">
              {getLink()}
            </a>
          </p>
        )}

        <div className="d-flex">
          <button className="btn btn-def" onClick={closeHandler}>
            Зрозуміло
          </button>
        </div>
      </div>
    </div>
  );
};
